import { isEmpty } from 'lodash'
import { getFilterLabel } from '../getFilterLabel'

const getFiltersLabel = (filters) => {
  if (isEmpty(filters)) return 'No filters applied'
  return filters.map(getFilterLabel).join(' and ')
}

export { getFiltersLabel }
